export default "__VITE_ASSET__F8Ynp2WI__"